import { memo, useState } from "react";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import ArticlesCreatorFragment from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/ArticlesCreatorFragment/ArticlesCreatorFragment";

function ArticlesCreatorFragmentDemo() {
  const [task, setTask] = useState<Record<string, unknown>>({
    details: {
      items: [],
    },
  });

  const configProps = {
    field: "details.items",
    maxArticles: 150,
  };

  const commonProps = {
    task,
    onTaskChange: (part: Record<string, unknown>) =>
      setTask((prev) => ({ ...prev, ...part })),
    blockInput: false,
    showValidation: false,
    taskType: { details: [] } as any,
  };

  return (
    <Demo>
      <Name>ArticlesCreatorFragment</Name>
      <Highlight>
        <FixaListView id="articlescreator" size="small">
          <ArticlesCreatorFragment
            configProps={configProps}
            commonProps={commonProps}
          />
        </FixaListView>
      </Highlight>
      <p>
        Displays multiple articles with ordered details. Requires article data
        from API.
      </p>
    </Demo>
  );
}

export default memo(ArticlesCreatorFragmentDemo);
